import React from 'react'
import { Events } from '../../component/events/Events'

export default function EventsPage() {
  return (
    <>
      <Events />
    </>
  )
}
